<template>
    <div v-for="(iban, i) in ibans" :key="i" class="grid grid-cols-[repeat(2,_minmax(0,_1fr))_max-content] gap-4 mb-3">
        <div class="flex flex-col">
            <Field :label-visible="false" v-model="iban.iban" placeholder="IBAN"
                   :errors="getErrors(i,'iban')"></Field>
        </div>
        <div class="flex flex-col">
            <Field :label-visible="false" v-model="iban.descrizione" placeholder="Descrizione"
                   :errors="getErrors(i,'descrizione')"
            ></Field>
        </div>
        <div class="flex items-center">
            <NextButton variant="outline-secondary" @click="removeIban(i)"
                        class="col flex justify-center items-center h-8 w-8"><i class="icon-x"></i></NextButton>
        </div>
    </div>

    <div class="flex justify-end">

        <NextButton variant="primary" @click="addIban"
                    class="col flex justify-center items-center h-8 w-8"><i class="icon-croce_quadrata"></i>
        </NextButton>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import ConfirmDelete from "@/components/ConfirmDelete.vue";
import Field from "@/components/Field.vue";
import NextButton from "@/components/NextButton.vue";

@Options({
    name: 'IbanForm',
    components: {NextButton, Field},
    props: {
        ibans: Array,
        errors: {
            type: Object,
            default: {}
        }
    }
})
export default class IbanForm extends Vue {
    ibans!: any[]
    errors!: any

    removeIban(idx: number) {
        this.ibans.splice(idx, 1)
        this.$emit('update:ibans', this.ibans)
    }

    addIban() {
        this.$emit('update:ibans', [...this.ibans, {iban: '', descrizione: ''}])
    }

    getErrors(index: string | number, field: string) {
        return (this.errors as any)[`ibans.${index}.${field}`]
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
